import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useAnalytics } from '@/context/analytics-context'

/**
 * 自动追踪页面浏览的 Hook
 * 使用 react-router 的 location 变化来触发页面浏览事件
 */
export function usePageTracking() {
  const location = useLocation()
  const { trackPageView, isInitialized } = useAnalytics()

  useEffect(() => {
    // 只有在 Analytics 初始化后才追踪
    if (isInitialized) {
      trackPageView(location.pathname + location.search, document.title)
    }
  }, [location, isInitialized, trackPageView])
}
